import { render, staticRenderFns } from "./empWagesList.vue?vue&type=template&id=3572cdb2&"
import script from "./empWagesList.vue?vue&type=script&lang=js&"
export * from "./empWagesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports